import React, { useRef, useEffect, useState } from "react"
import styles from "../../styles/footer.module.scss"
import Sizing from "./Sizing"
import { Link } from "gatsby"
import Spacing from "./Spacing"
import Form from "./Form"
import logo from "../../images/logo-sq-sml.png"
import formStyles from "../../styles/footer-form.module.scss"

const Footer = () => {
    const [success, setSuccess] = useState(false)

    const formOrSuccess = () => {
        if (!success) {
            return (
                <Form
                    type="footer"
                    styles={formStyles}
                    triggerSuccess={() => {
                        setSuccess(true)
                    }}
                ></Form>
            )
        } else {
            return (
                <div>
                    <span className={styles.heading + " h4"}>
                        Thank you for subscribing to Free Markets Destroy
                    </span>
                    <span className={styles.copy}>
                        You’ll hear from us soon.
                    </span>
                </div>
            )
        }
    }
    return (
        <div className={styles.main}>
            <Sizing
                breaks={[
                    {
                        min: 0,
                        val: {
                            paddingLeft: 1,
                            paddingRight: 1,
                            paddingTop: 2,
                            paddingBottom: 2,
                        },
                    },
                    {
                        min: 1024,
                        val: {
                            paddingLeft: 1,
                            paddingRight: 1,
                            paddingTop: 1,
                            paddingBottom: 1,
                        },
                    },
                ]}
            >
                <Sizing
                    breaks={[
                        {
                            min: 0,
                            val: {
                                marginBottom: 3,
                            },
                        },
                        {
                            min: 1024,
                            val: {
                                float: "right",
                                width: 11,
                                marginBottom: 0.5,
                            },
                        },
                    ]}
                >
                    <p className={"copy copy--white"}>
                        A project of <br />
                        <b>WASHINGTON POLICY CENTER</b>
                    </p>
                </Sizing>

                <Sizing
                    breaks={[
                        {
                            min: 0,
                            val: {},
                        },
                        {
                            min: 1024,
                            val: {
                                float: "left",
                                width: 11,
                            },
                        },
                    ]}
                >
                    <Sizing
                        breaks={[
                            {
                                min: 0,
                                val: {
                                    display: "none",
                                },
                            },
                            {
                                min: 1024,
                                val: {
                                    float: "left",
                                    width: 3.5,
                                    display: "block",
                                },
                            },
                        ]}
                    >
                        <img
                            style={{
                                width: "100%",
                                transform: "translate3d(0 , 0,1px)",
                            }}
                            src={logo}
                            alt=""
                        />
                    </Sizing>

                    <Sizing
                        breaks={[
                            {
                                min: 0,
                                val: {},
                            },
                            {
                                min: 1024,
                                val: {
                                    float: "left",
                                    width: 10.5,
                                    marginTop: 0.5,
                                },
                            },
                        ]}
                    >
                        <Sizing
                            breaks={[
                                {
                                    min: 0,
                                    val: {},
                                },
                                {
                                    min: 1024,
                                    val: {
                                        float: "left",
                                        marginBottom: 0.5,
                                        width: "100%",
                                    },
                                },
                            ]}
                        >
                            <span className={"copy copy--white"}>
                                {success ? "Success!" : "Stay up to date"}
                            </span>
                        </Sizing>

                        <div>
                            <div>{formOrSuccess()}</div>
                        </div>
                    </Sizing>
                </Sizing>

                <Sizing
                    breaks={[
                        {
                            min: 0,
                            val: { display: "block" },
                        },
                        {
                            min: 1024,
                            val: {
                                float: "right",
                                clear: "right",
                                width: 11,
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "flex-end",
                                justifyContent: "space-between",
                            },
                        },
                    ]}
                >
                    <Sizing
                        breaks={[
                            {
                                min: 0,
                                val: {
                                    marginTop: 3,
                                    float: "left",
                                },
                            },
                            {
                                min: 1024,
                                val: {
                                    float: "left",
                                    marginBottom: 0,
                                    // clear: "right",
                                    marginTop: 0,
                                    width: 7,
                                },
                            },
                        ]}
                    >
                        <a
                            target="_blank"
                            href="https://www.washingtonpolicy.org/marketsimproveeverything"
                            className={styles.link + " " + styles.arrow}
                        >
                            Markets Improve Everything <span>Blog</span>
                        </a>
                        <a target="_blank"
                           href="https://store.freemarketsdestroy.com"
                           className={styles.link + " " + styles.arrow}>
                            Get your Free Markets Destroy <span>Merch</span>
                        </a>
                    </Sizing>

                    <Sizing
                        breaks={[
                            {
                                min: 0,
                                val: {},
                            },
                            {
                                min: 1024,
                                val: {
                                    float: "right",
                                    width: 3,
                                },
                            },
                        ]}
                    >
                        <Sizing
                            breaks={[
                                {
                                    min: 0,
                                    val: { width: 14, float: "left" },
                                },
                                {
                                    min: 1024,
                                    val: { width: "auto", float: "none" },
                                },
                            ]}
                        >
                            <div className={styles.follow}>
                                Follow Free Markets Destroy on social
                            </div>
                        </Sizing>
                        <div className={styles.share}>
                            <a
                                target="_blank"
                                href="https://www.facebook.com/freemarketsdestroy/"
                                className={styles.fb}
                            ></a>
                            <a
                                target="_blank"
                                href="https://www.instagram.com/freemarketsdestroy/"
                                className={styles.inst}
                            ></a>
                        </div>
                    </Sizing>
                </Sizing>
                <Spacing space={0}></Spacing>
            </Sizing>

            <div className={styles.sub}>
                <Sizing
                    breaks={[
                        // {
                        //     min: 0,
                        //     val: {},
                        // },
                        {
                            min: 0,
                            val: {
                                float: "left",
                                width: 22,
                                marginLeft: 1,
                                height: "100%",
                            },
                        },
                    ]}
                >
                    <div className={styles.subtext}>
                        <span>
                            Nothing here should be construed as an attempt to
                            aid or hinder the passage of any legislation before
                            any legislative body
                        </span>

                        <span>
                            Free Markets Destroy is a project of
                            <a
                                target="_blank"
                                href="https://www.washingtonpolicy.org/"
                            >
                                {" "}
                                Washington Policy Center
                            </a>{" "}
                            | <Link to="/en/privacy-policy">Privacy Policy</Link>
                        </span>
                    </div>
                </Sizing>
            </div>
        </div>
    )
}

export default Footer
